import { render, staticRenderFns } from "./Dias.vue?vue&type=template&id=b09dd4f8&scoped=true&"
import script from "./Dias.vue?vue&type=script&lang=js&"
export * from "./Dias.vue?vue&type=script&lang=js&"
import style0 from "./Dias.vue?vue&type=style&index=0&id=b09dd4f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09dd4f8",
  null
  
)

export default component.exports